if (!customElements.get('salut-sort')) {
  class SalutSort extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.salut-sort__trigger');
      this.panel = this.querySelector('.salut-sort__panel');
      this.input = this.querySelector('[data-salut-sort-input]');
      this.value = this.querySelector('.salut-sort__value');
      this.options = Array.from(this.querySelectorAll('.salut-sort__option'));

      if (!this.trigger || !this.panel || !this.input || this.options.length === 0) return;

      this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
      this.onDocumentFocusIn = this.onDocumentFocusIn.bind(this);

      this.trigger.addEventListener('click', () => this.toggle());
      this.trigger.addEventListener('keydown', (event) => this.onTriggerKeydown(event));
      this.panel.addEventListener('keydown', (event) => this.onPanelKeydown(event));

      this.options.forEach((option) => {
        option.setAttribute('tabindex', '-1');
        option.addEventListener('click', () => this.select(option));
      });
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      document.removeEventListener('focusin', this.onDocumentFocusIn);
    }

    get isOpen() {
      return this.trigger.getAttribute('aria-expanded') === 'true';
    }

    get selectedOption() {
      return this.options.find((option) => option.getAttribute('aria-selected') === 'true') || this.options[0];
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open(focusTarget) {
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      this.classList.add('salut-sort--open');
      document.addEventListener('pointerdown', this.onDocumentPointerDown);
      document.addEventListener('focusin', this.onDocumentFocusIn);
      this.focusOption(focusTarget || this.selectedOption);
    }

    close(restoreFocus) {
      if (!this.isOpen) return;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
      this.classList.remove('salut-sort--open');
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      document.removeEventListener('focusin', this.onDocumentFocusIn);
      if (restoreFocus) this.trigger.focus();
    }

    focusOption(option) {
      if (!option) return;
      this.options.forEach((item) => item.classList.toggle('salut-sort__option--active', item === option));
      this.panel.setAttribute('aria-activedescendant', option.id);
      option.focus();
    }

    moveFocus(step) {
      const active = this.options.find((option) => option.classList.contains('salut-sort__option--active'));
      const from = active ? this.options.indexOf(active) : this.options.indexOf(this.selectedOption);
      const next = Math.min(this.options.length - 1, Math.max(0, from + step));
      this.focusOption(this.options[next]);
    }

    onTriggerKeydown(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (this.isOpen) {
          this.moveFocus(event.key === 'ArrowDown' ? 1 : -1);
        } else {
          this.open();
        }
      } else if (event.key === 'Escape' && this.isOpen) {
        event.preventDefault();
        this.close(true);
      }
    }

    onPanelKeydown(event) {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          this.moveFocus(1);
          break;
        case 'ArrowUp':
          event.preventDefault();
          this.moveFocus(-1);
          break;
        case 'Home':
          event.preventDefault();
          this.focusOption(this.options[0]);
          break;
        case 'End':
          event.preventDefault();
          this.focusOption(this.options[this.options.length - 1]);
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.select(this.options.find((option) => option.classList.contains('salut-sort__option--active')));
          break;
        case 'Escape':
          event.preventDefault();
          this.close(true);
          break;
        case 'Tab':
          this.close();
          break;
        default:
          break;
      }
    }

    onDocumentPointerDown(event) {
      if (!this.contains(event.target)) this.close();
    }

    onDocumentFocusIn(event) {
      if (!this.contains(event.target)) this.close();
    }

    sync(value) {
      const option = this.options.find((item) => item.dataset.value === value);
      if (!option) return;
      this.options.forEach((item) => item.setAttribute('aria-selected', String(item === option)));
      this.value.textContent = option.textContent.trim();
      this.input.value = value;
    }

    select(option) {
      if (!option) return;
      const value = option.dataset.value;
      this.sync(value);
      this.close(true);

      document.querySelectorAll('salut-sort').forEach((element) => {
        if (element !== this && typeof element.sync === 'function') element.sync(value);
      });
      document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
        select.value = value;
      });

      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  customElements.define('salut-sort', SalutSort);
}
